import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { IEventHistory, EventType } from '../../../../models/History';
import { EventHistoryService } from '../../../core/data-sources/event-history.service';
import { trigger, state, animate, style, transition } from '@angular/animations';
import { toEditedUnloadEventHistoryItem } from './edited-unload/to-edit-unloaded-event-history-item';
import { toEventHistoryItem } from './to-event-history-item';
import { toPalletTransferEventHistoryItem } from './pallet-transfer/to-pallet-transfer-event-history-item';

@Component({
  selector: 'app-movement-details',
  templateUrl: './movement-details.component.html',
  styleUrls: ['./movement-details.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})

export class MovementDetailsComponent implements OnInit {
  @Input() crateId: string;
  @Input() title: string;
  @Input() warning: string | null = null;
  @Output() openPalletDetailsRequested = new EventEmitter<any>();
  displayedColumns = ['action', 'eventName', 'taskType', 'user', 'deviceName', 'position', 'height', 'movedAt'];
  columnsDefinition = [
    { key: "eventName", text: "Tipo de evento" },
    { key: "taskType", text: "Tarefa" },
    { key: "user", text: "Usuário" },
    { key: "deviceName", text: "Aparelho" },
    { key: "coords", text: "Coordenada" },
    { key: "position", text: "Posição" },
    { key: "levelName", text: "Nível" },
    { key: "height", text: "Altura" },
    { key: "movedAt", text: "Data do evento" },
  ];
  productsTableDisplayedColumns = ['sku', 'name', 'quantity'];
  productsTableColumnDefinition = [
    { key: 'sku', text: "Código do Item" },
    { key: 'name', text: "Nome" },
    { key: 'quantity', text: 'Quantidade', alignRight: true }
  ];
  dataMovement: IEventHistory[] = [];
  tableData: unknown[] = []; //TODO add type
  expandedElement: IEventHistory | null;
  isLoading = true;

  public EventType = EventType


  constructor(private eventHistoryService: EventHistoryService) { }

  ngOnInit(): void {
    this.getMovementHistory();
  }

  async getMovementHistory(): Promise<void> {
    this.dataMovement = await this.eventHistoryService.getEventHistory(this.crateId);
    this.formatData(this.dataMovement);
    setTimeout(() => {
      this.isLoading = false;
    }, 500);
  }

  formatData(data: IEventHistory[]) {
    this.tableData = data.map((element) => {
      switch(element.type) {
        case EventType.EDITED_UNLOAD:
          return toEditedUnloadEventHistoryItem(element);
        case EventType.TRANSFER_IN:
        case EventType.TRANSFER_OUT:
          return toPalletTransferEventHistoryItem(element);
        default:
          return toEventHistoryItem(element);
      }
    });
  }

  handleOpenPalletDetails(palletData) {
    this.openPalletDetailsRequested.emit(palletData);
  }
}
